import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login, user, ready } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (ready && user) navigate("/admin", { replace: true });
  }, [ready, user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin", { replace: true });
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const input = "w-full bg-[#0d0d0d] border border-white/10 px-4 py-3.5 text-[#F5F5F0] placeholder:text-[#5a5a5a] focus:outline-none focus:border-gold transition-colors duration-300";

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6 font-body">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="w-full max-w-md">
        <a href="/" className="flex justify-center mb-8"><img src="/logo.png" alt="247 Aftermath" className="h-20 w-auto" /></a>
        <div className="border border-white/10 bg-[#0a0a0a] p-8">
          <div className="flex items-center gap-3 mb-6">
            <span className="flex h-10 w-10 items-center justify-center border border-gold/40 text-gold"><Lock className="h-5 w-5" /></span>
            <div>
              <h1 className="font-display text-2xl">Team Login</h1>
              <p className="text-xs text-[#A3A3A3] font-mono tracking-widest uppercase">CRM Dashboard</p>
            </div>
          </div>
          <form onSubmit={submit} className="space-y-5" data-testid="login-form">
            <div>
              <label className="font-mono text-[11px] tracking-widest uppercase text-[#A3A3A3]">Email</label>
              <input className={`${input} mt-2`} type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@aftermathmgmt.com" data-testid="login-email" />
            </div>
            <div>
              <label className="font-mono text-[11px] tracking-widest uppercase text-[#A3A3A3]">Password</label>
              <input className={`${input} mt-2`} type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="login-password" />
            </div>
            <button type="submit" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 bg-gold text-black font-semibold px-8 py-4 hover:bg-gold-light transition-colors duration-300 disabled:opacity-60" data-testid="login-submit">
              {loading ? <><Loader2 className="h-5 w-5 animate-spin" /> Signing in…</> : "Sign In"}
            </button>
          </form>
        </div>
        <a href="/" className="block text-center mt-6 text-sm text-[#A3A3A3] hover:text-gold transition-colors">← Back to website</a>
      </motion.div>
    </div>
  );
}
